import React from 'react';
import { ProductDetail } from '../components/products/ProductDetail';

export const ProductDetailPage: React.FC = () => {
  return (
    <div className="animate-fade-in">
      <ProductDetail />
    </div>
  );
};